import React from "react";
import { Dialog } from "@headlessui/react";

interface ProgressModalProps {
  message?: string;
}

export default function ProgressModalV2({ message = "Processing..." }: ProgressModalProps) {
  return (
    <div>
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        @keyframes pulse-glow {
          0%, 100% {
            box-shadow: 0 0 20px rgba(34, 197, 94, 0.4);
          }
          50% {
            box-shadow: 0 0 30px rgba(34, 197, 94, 0.8);
          }
        }
        @keyframes progress {
          0% {
            width: 0%;
            left: 0%;
          }
          50% {
            width: 75%;
            left: 0%;
          }
          100% {
            width: 100%;
            left: 100%;
          }
        }
        .shimmer {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite;
        }
        .pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }
        .progress-bar {
          position: relative;
          overflow: hidden;
        }
        .progress-fill {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 30%;
          background: linear-gradient(
            90deg,
            rgba(34, 197, 94, 0.3) 0%,
            rgba(74, 222, 128, 0.8) 50%,
            rgba(34, 197, 94, 0.3) 100%
          );
          animation: progress 1.5s ease-in-out infinite;
        }
      `}</style>
      <div>
        <div className="text-center">
          <Dialog.Title
            as="h3"
            className="text-lg font-semibold leading-6 text-gray-700 mb-4"
          >
            {message}
          </Dialog.Title>
          <div>
            <div className="w-full bg-green-100 rounded-full h-2 overflow-hidden progress-bar">
              <div className="progress-fill"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

